import React from 'react';
import Container from '../../primitives/grid/container';
import Row from '../../primitives/grid/row';
import Col from '../../primitives/grid/col';
import DownloadIcon from '../../../images/arrow-down-to-bracket-light.svg';

interface DownloadProps {
    title?: PressLessPlainText
    file?: PressLessFile | { href: string }
    className?: string
    style?: any;
}

const Download: PressLessComponent<DownloadProps> = React.forwardRef<HTMLDivElement, DownloadProps>(({
    title, className, file, style,
}, ref) => (
    (
        <div ref={ref} css={{ width: '100%' }}>
            <div
                className={className}
                css={{
                    width: '100%',
                    display: 'flex',
                    position: 'relative',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                }}
            >
                <Container css={style}>
                    <Row
                        css={{
                            width: '100%',
                            height: 'auto',
                            alignItems: 'flex-start',
                            backgroundColor: 'var(--color-gray-almostwhite)',
                            padding: '22px',
                            transition: 'all 0.3s linear',
                            position: 'relative',
                            '&:hover': {
                                backgroundColor: 'var(--color-gray-hellgrau)',
                            },
                            borderRadius: '8px',
                            '@media (max-width: 767px)': {
                                padding: '16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                            },
                        }}
                    >
                        <Col
                            breakpoints={{ dt: { span: 11, rightGap: 'full' } }}
                            css={{
                                width: '100%',
                                height: 'auto',
                                display: 'flex',
                                // alignItems: 'center',
                                '@media (max-width: 767px)': {
                                    width: 'auto',
                                    flexShrink: 1,
                                },
                            }}
                        >
                            <a
                                {...file}
                                download
                                className="p1"
                                css={{
                                    color: '#383F42',
                                    wordBreak: 'break-word',
                                    '@media (max-width: 767px)': {
                                        marginRight: '15px',
                                    },
                                }}
                            >
                                {title}
                            </a>
                        </Col>
                        <Col
                            breakpoints={{ dt: { span: 1, rightGap: 'none' } }}
                            css={{
                                height: '100%',
                                justifyContent: 'center',
                                '@media (max-width: 767px)': {
                                    margin: '0',
                                    paddingRight: '16px',
                                    alignSelf: 'center',
                                },
                            }}
                        >
                            <a
                                {...file}
                                download
                                css={{
                                    position: 'absolute',
                                    right: '25.69px',
                                }}
                            >
                                <DownloadIcon
                                    css={{
                                        width: '29px',
                                        height: '32px',
                                        objectFit: 'cover',
                                        '@media (max-width: 767px)': {
                                            width: '20px',
                                            height: '23px',
                                        },
                                    }}
                                />
                            </a>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
));

Download.pressless = {
    name: 'Download',
    attributes: {
        title: {
            name: 'Titel',
            type: 'PlainText',
        },
        file: {
            name: 'Datei',
            type: 'File',
        },
    },
};

export default Download;
